import Container from 'react-bootstrap/Container';
import "./footer.scss";

const Footer = () => {
    return (
        <>
            <footer className="footpage">
                <Container>
                    <div className="footer-copyright text-left"><span className="first">Copyright @{new Date().getFullYear()}</span> <span className="second">LaroPay Co.</span></div>
                    <ul className="privacy">
                        <li><a href="/term">Terms of Service</a></li>
                        <li><a href="/privacy">Privacy Policy</a></li>
                    </ul>
                </Container>


            </footer>
        </>
    );
}

export default Footer;